import { module } from 'modujs';
import { gsap } from '../gsap'

export default class extends module {
    constructor(m) {
        super(m);

        this.$logo = this.$('logo')[0]
        this.$svg = this.$logo.querySelector('svg')
        this.$svgLetters = Array.from(this.$svg.children)
        this.$shoe = this.$('shoe')
        this.$shoe = this.$shoe.length > 0 ? this.$shoe[0] : false
    }

    init() {

        this.setTimeline()

        window.addEventListener('resizeEnd', this.onResize = () => this.resize())
    }

    setTimeline() {

        this.tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.el,
                start: '30% bottom',
                end: '90% bottom',
                scrub: 1,
                default: {
                    ease: 'power2.inOut'
                }
            },
        })

        this.tl
            .fromTo(this.$svgLetters,
                {
                    y: 0,
                    yPercent: 105
                },
                {
                    y: 0,
                    yPercent: 0,
                    duration: 1,
                    stagger: {
                        amount: 1
                    },
                }, 0)

        if(this.$shoe) {
            this.tl.from(this.$shoe, {
                yPercent: 150,
                duration: 2,
                ease: 'power2.out'
            }, 0)
        }
    }

    resize() {

        this.tl.scrollTrigger.kill(true)
        this.tl.kill(true)

        const $elements = [this.$svgLetters]

        if(this.$shoe) {
            $elements.push(this.$shoe)
        }

        gsap.set($elements, {
            clearProps: 'all'
        })

        this.setTimeline()
    }

    destroy() {
        this.tl.kill()

        window.removeEventListener('resizeEnd', this.onResize)
    }
}
